import charts from '../charts.js';
import fundamentalsChart from '../charts/fundamentals.js';
import ChartPage from '../includes/chart-page.js';
import moment from 'moment';

let chartPage;
let numFutureWeeks = 52;
let type;
let timespan;

const estimates = [
	'quarter_revenue',
	'quarter_earnings',
	'year_revenue',
	'year_earnings',
];

export default async function seasonalitySection(res, section, data) {
	chartPage = new ChartPage();

	numFutureWeeks = res.numFutureWeeks || 52;

	const chartDefaults = _.pick(res, [
		'defaultTimespan', 'defaultType'
	]);

	timespan = chartDefaults.defaultTimespan;
	type = chartDefaults.defaultType;

	await chartPage.init({
		res,
		section,
		data,
		sectionName: 'fundamentals',
		hasRemainingData: false,
		chartDefaults,
		chartSettings: fundamentalsChart,
		timePeriod: 'weeks',
		sliderDefault: 52,
		callbacks: {
			buildEmbed: () => ({
				defaultTimespan: timespan,
				defaultType: type,
			}),

			drawChart() {
				const shownEstimate = `${timespan}_${type}`;

				for (const estimate of estimates) {
					chartPage.chart.toggleSeries(estimate, estimate === shownEstimate);
				}
			},

			getEndDate: () => {
				return moment(res.lastData.date).add(numFutureWeeks, 'week');
			},
		},
	});

	if (chartPage.form) {
		chartPage.form.setCallback('analysts-timespan', 'set', (value) => {
			timespan = value;
			chartPage.drawChart();
		});

		chartPage.form.setCallback('analysts-type', 'set', (value) => {
			type = value;
			chartPage.drawChart();
		});
	}
}
